// @ts-nocheck
import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "../../assets/images/Common/EditIcon.png";
import DeleteIcon from "../../assets/images/Common/deleteIcon.png";

import { Button } from "../Button/Button";
import { Toolbar } from "primereact/toolbar";
import {
  BudgetContainer,
  BudgetInfo,
  CustomDialogFooter,
  ActionButton,
  TableConatiner,
  DropdownContainer,
  DropdownTrigger,
  DropdownMenu,
  Caret,
  DropdownItem,
} from "./BudgetList.styles";
import CreateBudgetModel from "./components/CreateBudgetModel/CreateBudgetModel";
import { StyledToast } from "../CreateNewUser/CreateNewUser.styles";
import Modal from "../Modal/Modal";
import { PrimeReactProvider } from "primereact/api";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getBudgetItems,
  createBudgetItem,
  deleteBudgetItem,
  getBudgetCategories,
  selectBudgetCategories,
  projectByIdSelector,
} from "../../redux";
import { formatBudgetItems } from "../../utils/common/validation";
import { updateBudgetItem } from "../../redux/actions/set/setUpdateBudgetItem";
import { formatCurrency } from "../../utils";
import EmptyTable from "../UnitInformation/EmptyTable/EmptyTable";
import useReadOnlyUser from "../../hooks/useReadOnlyUser";
import { Color } from "../../styles/Colors";
import { BudgetExtractor } from "../BudgetExtractor/BudgetExtractor";
import { CustomToolbar } from "../ToolBar/CustomToolbar";
import { BudgetFileHeaders } from "../../constants";
import moment from "moment";
import { CustomDataTable } from "../DataTable/CustomDataTable";
import { ColumnDef } from "@tanstack/react-table";

export const itemsFields = ["Category", "Budget Item Description", "Amount"];

export const BudgetList: React.FC<{
  pId: string | undefined;
  cId: string | undefined;
  pName: string | undefined;
}> = ({ cId, pId, pName }) => {
  const dispatch = useDispatch();

  const [products, setProducts] = useState(null);
  const [categories, setCategories] = useState(null);
  const [productDialog, setProductDialog] = useState(false);
  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [showExportOptions, setShowExportOptions] = useState(false);

  const bdgtCategoryOptions = useSelector(selectBudgetCategories).map(
    (item) => ({ label: item.bdgtCategory, value: item.bdgtCategory })
  );

  const { currentProject = {} } = useSelector(projectByIdSelector);
  const cLoanId = currentProject.pLoanId;
  const isReadonlyUser = useReadOnlyUser();

  const notifyError = (message) =>
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const notifySuccess = (message) => {
    toast.success(message, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const getAllBudgets = () => {
    setLoading(true);

    dispatch(
      getBudgetCategories({ pId, cId }, (GetBudgetCategories) => {
        setCategories(GetBudgetCategories);
        // setLoading(false);
      })
    );

    dispatch(
      getBudgetItems({ pId, cId }, (GetBudgetItems) => {
        setProducts(GetBudgetItems);
        setLoading(false);
      })
    );
  };

  useEffect(() => {
    getAllBudgets();
  }, []);

  const openNew = () => {
    setProduct(null);
    setProductDialog(true);
  };

  const hideDialog = () => {
    setProductDialog(false);
    setProduct(null);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };
  /*
  const columns: ColumnDef<any>[] = [
    {
      accessorKey: "bdgtCategory",
      header: "Category",
      cell: (info) => {
        const val = info.getValue();
        return val && val !== "Select Category"
          ? `${val.charAt(0).toUpperCase()}${val.slice(1)}`
          : "";
      },
      enableSorting: true,
    },
    {
      accessorKey: "bdgtDesc",
      header: "Description",
      enableSorting: true,
    },
    {
      accessorKey: "amt",
      header: "Amount",
      cell: (info) => formatCurrency(info.getValue()),
      enableSorting: true,
    },
    {
      accessorKey: "updatedOn",
      header: "Updated On",
      enableSorting: true,
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => actionBodyTemplate(row.original),
      enableSorting: false,
    },
  ];
  */

  const saveProduct = (items) => {
    setBtnLoading(true);
    const modifiedItems = formatBudgetItems(items, pId, cId);
    dispatch(
      createBudgetItem({ items: modifiedItems }, (res) => {
        if (res?.success) {
          getAllBudgets();
          notifySuccess(
            `${
              product != null && product?.category
                ? "Budget item updated"
                : "Budget item created"
            } successfully!`
          );
        } else {
          notifyError("Failed to create budget item!");
        }
        setBtnLoading(false);
        hideDialog();
      })
    );
  };

  const editProduct = (product) => {
    setProduct({ ...product });
    setProductDialog(true);
  };

  const confirmDeleteProduct = (product) => {
    setProduct(product);
    setDeleteProductDialog(true);
  };

  const deleteBudget = () => {
    const { bdgtLnItmId } = product || {};
    setBtnLoading(true);
    dispatch(
      deleteBudgetItem({ bdgtLnItmId: bdgtLnItmId, pId, cId }, (res) => {
        if (res?.success) {
          getAllBudgets();
          notifySuccess("Budget item deleted successfully!");
        } else {
          notifyError("Failed to delete budget item!");
        }
        setBtnLoading(false);
        setDeleteProductDialog(false);
      })
    );
  };

  const openPopUp = () => {
    setPopUpOpen(true);
  };

  const closePopUp = () => {
    setPopUpOpen(false);
  };

  const handleExport = (type) => {
    setShowExportOptions(false);

    if (!products || products.length === 0) {
      notifyError("No Budget items Present");
      return;
    }

    const timestamp = moment().format("YYMMDD");
    let csv = "";
    const filename = cLoanId
      ? `${cLoanId}_budget_${timestamp}.csv`
      : `budget_${timestamp}.csv`;

    if (type === "LEVEL") {
      // use the converter (no side-effect) to get CSV string
      csv = convertToCSV2(categories, products);
    } else {
      csv = convertToCSV(products);
    }

    // single download action
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);

    // Notify user after successful download trigger
    notifySuccess("CSV export generated successfully");
  };

  // Change Here
  const convertToCSV2 = (categories, products) => {
    const escapeIfNeeded = (value) => {
      if (value === null || value === undefined) return "";
      const str = String(value);
      return str.includes(",") ? `"${str.replace(/"/g, '""')}"` : str;
    };

    // Build category → cost code lookup
    const categoryMap = {};
    categories.forEach((cat) => {
      categoryMap[cat.bdgtCategory] = cat.bdgtCostCode;
    });

    let csv = "Cost Code,ItemDesc,Cost\n";

    products.forEach((product) => {
      const costCode = categoryMap[product.bdgtCategory] || "";
      const itemDesc = product.bdgtDesc || "";
      const cost = product.amt ?? "";

      csv +=
        [
          escapeIfNeeded(costCode),
          escapeIfNeeded(itemDesc),
          escapeIfNeeded(cost),
        ].join(",") + "\n";
    });

    return csv.trimEnd();
  };

  const convertToCSV = (arr) => {
    const headerRow = BudgetFileHeaders.map((h) => h.label).join(",");

    const descRow1 = BudgetFileHeaders.map((h) => {
      switch (h.label) {
        case "IMPORTFILE":
          return JSON.stringify("FORMAT");
        case "Name":
          return JSON.stringify("Cannot exceed 255 characters");
        case "Description":
          return JSON.stringify("Cannot exceed 255 characters");
        case "Type":
          return JSON.stringify(
            "Must contain a valid item type: hard, land, soft, closing, contingency_reserve, interest_reserve, custom_fee, inspection_fee, general_fee"
          );
        case "Budget Amount":
          return JSON.stringify("Must contain a valid amount");
        case "% Weight":
          return JSON.stringify("Must contain a valid number 0-100");
        case "Phase":
          return JSON.stringify("Cannot exceed 255 characters");
        case "% Complete":
          return JSON.stringify("Must contain a valid number 0-100");
        case "Funded Amount":
          return JSON.stringify(
            "Must contain a valid amount. Cannot be greater than budget amount"
          );
        case "Remaining Amount":
          return JSON.stringify("Must contain a valid amount");
        case "Prepaid Amount":
          return JSON.stringify("Must contain a valid amount");
        default:
          return JSON.stringify("");
      }
    }).join(",");

    const descRow2 = BudgetFileHeaders.map((h) => {
      switch (h.label) {
        case "IMPORTFILE":
          return JSON.stringify("VERSION:1.1");
        case "Name":
          return JSON.stringify("REQUIRED");
        case "Type":
          return JSON.stringify("REQUIRED");
        case "Budget Amount":
          return JSON.stringify("REQUIRED");
        default:
          return JSON.stringify("");
      }
    }).join(",");

    const rows = arr.map((obj) =>
      BudgetFileHeaders.map((h) => {
        // if (h.label === "IMPORTFILE") {
        //   const value = obj.hasOwnProperty(h.key) ? obj[h.key] : "";
        //   return JSON.stringify(`VERSION:${value}`);
        // }
        if (h.label === "Type") {
          return JSON.stringify("hard");
        }
        if (h.label === "Description") {
          return JSON.stringify(cLoanId ? cLoanId : "");
        }
        const value = obj.hasOwnProperty(h.key) ? obj[h.key] : "";
        return JSON.stringify(value);
      }).join(",")
    );

    return [headerRow, descRow1, descRow2, ...rows].join("\n");
  };

  const sum =
    products !== null &&
    products?.reduce((acc, obj) => acc + Number(obj.amt), 0);

  const leftToolbarTemplate = () => {
    return (
      <BudgetInfo>
        <span>Budget: {formatCurrency(sum)}</span>-
        <span>{products !== null && products?.length} Items</span>
      </BudgetInfo>
    );
  };

  const centerToolbarTemplate = () => null;

  const rightToolbarTemplate = () => (
    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
      {/* <Button onClick={downloadCSV} disabled={isReadonlyUser}>
        Export CSV
      </Button> */}

      <DropdownContainer>
        <Button onClick={() => setShowExportOptions((v) => !v)}>
          <DropdownTrigger>
            Export CSV <Caret>▾</Caret>
          </DropdownTrigger>
        </Button>

        {showExportOptions && (
          <DropdownMenu>
            <DropdownItem onClick={() => handleExport("LEVEL")}>
              Level
            </DropdownItem>
            <DropdownItem onClick={() => handleExport("BUILT")}>
              BUILT
            </DropdownItem>
          </DropdownMenu>
        )}
      </DropdownContainer>

      <Button onClick={openPopUp}>Import Budget</Button>

      <Button
        type="button"
        onClick={openNew}
        // hasStartIcon={true}
        // className="btn-primary"
        disabled={isReadonlyUser}
      >
        Create Budget Items
      </Button>

      {popUpOpen && (
        <BudgetExtractor
          open={popUpOpen}
          onClose={closePopUp}
          projectUuid={pId || ""}
          companyId={cId || ""}
          onBudgetSaved={getAllBudgets}
        />
      )}
    </div>
  );

  const actionBodyTemplate = (rowData) => {
    return (
      <ActionButton>
        <Button
          type="button"
          onClick={() => editProduct(rowData)}
          className="btn-default"
          disabled={isReadonlyUser}
        >
          <img src={EditIcon} alt="editIcon" />
        </Button>
        <Button
          type="button"
          onClick={() => confirmDeleteProduct(rowData)}
          className="btn-default"
          disabled={isReadonlyUser}
        >
          <img src={DeleteIcon} alt="deleteIcon" />
        </Button>
      </ActionButton>
    );
  };

  const editBudget = ([inputValues]) => {
    const {
      Amount: amt,
      Category,
      "Budget Item Description": bdgtDesc,
    } = inputValues;
    const { label: bdgtCategory } = Category;

    const { bdgtLnItmId, bdgt_line_item_version: version } = product || {};
    // const updatedOn = new Date().toISOString().split("T")[0];
    // const updatedOn = new Date()
    //   .toISOString()
    //   .replace("T", " ")
    //   .replace("Z", "");
    const updatedOn = new Date().toISOString();

    setBtnLoading(true);
    dispatch(
      updateBudgetItem(
        {
          bdgtLnItmId: bdgtLnItmId,
          pId,
          cId,
          bdgtDesc,
          amt,
          bdgtCategory,
          updatedOn,
          // bdgt_line_item_version: version,
        },
        (res) => {
          if (res?.success) {
            getAllBudgets();
            notifySuccess("Budget item updated successfully!");
          } else {
            notifyError("Not able to edit budget");
          }
          setBtnLoading(false);
          hideDialog();
        }
      )
    );
  };

  const deleteProductDialogFooter = (
    <CustomDialogFooter>
      <Button
        type="button"
        className="btn-default"
        onClick={hideDeleteProductDialog}
      >
        Cancel
      </Button>
      <Button
        type="button"
        className="btn-primary"
        onClick={deleteBudget}
        isLoading={btnLoading}
      >
        Delete
      </Button>
    </CustomDialogFooter>
  );

  const colunmStyle = {
    padding: "10px 8px",
    border: `1px solid ${Color.gray}`,
  };

  return (
    <BudgetContainer>
      <PrimeReactProvider>
        <div>
          <StyledToast />
          <div className="card">
            <CustomToolbar
              style={{ backgroundColor: "unset", border: "none" }}
              className="mb-2"
              left={leftToolbarTemplate}
              center={centerToolbarTemplate}
              right={rightToolbarTemplate}
            />

            <TableConatiner>
              <DataTable
                value={products}
                size="small"
                className="tight-table"
                tableStyle={{
                  minWidth: "50rem",
                  border: `1px solid ${Color.gray}`,
                }}
                emptyMessage={<EmptyTable tableName={"Budget"} />}
                loading={loading}
              >
                <Column
                  sortable
                  field="bdgtCategory"
                  header="Category"
                  style={colunmStyle}
                  body={({ bdgtCategory }) =>
                    bdgtCategory && bdgtCategory !== "Select Category"
                      ? `${bdgtCategory
                          .slice(0, 1)
                          .toUpperCase()}${bdgtCategory.slice(1)}`
                      : ""
                  }
                ></Column>
                <Column
                  sortable
                  field="bdgtDesc"
                  header="Description"
                  style={colunmStyle}
                ></Column>
                <Column
                  sortable
                  field="amt"
                  header="Amount"
                  style={colunmStyle}
                  body={({ amt }) => formatCurrency(amt)}
                ></Column>
                <Column
                  sortable
                  field="updatedOn"
                  header="Updated on"
                  style={colunmStyle}
                ></Column>
                <Column
                  field="actions"
                  header="Actions"
                  body={actionBodyTemplate}
                  exportable={false}
                  style={{
                    minWidth: "12rem",
                    border: `1px solid ${Color.gray}`,
                  }}
                  alignFrozen="right"
                  frozen
                ></Column>
              </DataTable>
            </TableConatiner>
            {/* <CustomDataTable
              data={products || []}
              columns={columns}
              loading={loading}
            /> */}
          </div>

          {productDialog && (
            <CreateBudgetModel
              onClose={hideDialog}
              isOpen={productDialog}
              product={product}
              saveProduct={saveProduct}
              editBudget={editBudget}
              pName={pName}
              btnLoading={btnLoading}
              categoryOptions={bdgtCategoryOptions}
            />
          )}

          {deleteProductDialog && (
            <Modal
              open={deleteProductDialog}
              header="Delete Budget Item?"
              modal
              footer={deleteProductDialogFooter}
              onClose={hideDeleteProductDialog}
            >
              <p>Are you sure, you want to delete this budget item?</p>
            </Modal>
          )}
        </div>
      </PrimeReactProvider>
    </BudgetContainer>
  );
};

export default BudgetList;
